import { AppCategory, AppDeploymentStatus, DigitalAiAsset, FunnelStage } from '../types';

const categories: AppCategory[] = ['agent', 'rag_knowledge', 'workflow', 'vision_multimodal', 'voice_bot', 'lead_qualifier'];
const statuses: AppDeploymentStatus[] = ['deployed', 'in_development', 'testing', 'archived'];
const stages: FunnelStage[] = ['personal', 'education', 'offer', 'attraction', 'nurturing', 'registration', 'delivery', 'attendance', 'retention'];
const models: DigitalAiAsset['model'][] = ['Gemini 2.5 Pro', 'Gemini 2.5 Flash', 'Custom Fine-Tuned', 'Anthropic Claude', 'OpenAI GPT-4o'];

function nonNegativeNumber(value: unknown) {
  return typeof value === 'number' && Number.isFinite(value) && value >= 0 ? value : 0;
}

export function sanitizeDigitalAiAssets(value: unknown): DigitalAiAsset[] | null {
  if (!Array.isArray(value)) return null;

  return value.flatMap((raw): DigitalAiAsset[] => {
    if (!raw || typeof raw !== 'object') return [];
    const item = raw as Record<string, unknown>;
    if (typeof item.id !== 'string' || typeof item.name !== 'string' || typeof item.description !== 'string') return [];

    const dataSource = item.dataSource === 'provider' ? 'provider' : 'demo';
    const systemInstruction = typeof item.systemInstruction === 'string' ? item.systemInstruction : null;
    const linkedCanvasNodeId = typeof item.linkedCanvasNodeId === 'string' ? item.linkedCanvasNodeId : null;
    const endpointUrl = dataSource === 'provider' && typeof item.endpointUrl === 'string' ? item.endpointUrl : null;
    return [{
      id: item.id,
      name: item.name,
      description: item.description,
      category: categories.includes(item.category as AppCategory) ? item.category as AppCategory : 'agent',
      targetStage: stages.includes(item.targetStage as FunnelStage) ? item.targetStage as FunnelStage : 'attraction',
      status: statuses.includes(item.status as AppDeploymentStatus) ? item.status as AppDeploymentStatus : 'testing',
      model: models.includes(item.model as DigitalAiAsset['model']) ? item.model as DigitalAiAsset['model'] : 'Gemini 2.5 Flash',
      ...(systemInstruction ? { systemInstruction } : {}),
      tokensUsedThisMonth: dataSource === 'provider' ? nonNegativeNumber(item.tokensUsedThisMonth) : 0,
      totalExecutions: dataSource === 'provider' ? nonNegativeNumber(item.totalExecutions) : 0,
      successfulExecutions: dataSource === 'provider' ? nonNegativeNumber(item.successfulExecutions) : 0,
      ...(dataSource === 'provider' ? { lastLatencyMs: nonNegativeNumber(item.lastLatencyMs) } : {}),
      ...(linkedCanvasNodeId ? { linkedCanvasNodeId } : {}),
      ...(endpointUrl ? { endpointUrl } : {}),
      techStack: Array.isArray(item.techStack) ? item.techStack.filter((entry): entry is string => typeof entry === 'string') : [],
      dataSource,
    }];
  });
}
